<template>
  <div class="word-list11">
    <div
      class="head"
      :style="{
        backgroundImage: 'url(' + dataInfo.cover + ')'
      }"
    >
      {{ dataInfo.name }}
    </div>
    <div class="g-box">
      <RecList />
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";
import RecList from "../../components/RecList";

export default {
  data() {
    return {
      query: this.$route.query,
      dataInfo: {},
      dataList: []
    };
  },
  mixins: [pageMain_mx],
  components: { RecList },
  mounted() {},
  methods: {
    async init() {
      const dataInfo = await this.getMenuInfo(this.query.id);
      this.dataInfo = dataInfo;
    }
  }
};
</script>
<style lang="less">
.word-list11 {
  .head {
    height: 280px;
    // width: 1920px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 60px;
    color: #fff;
    letter-spacing: 40px;
  }
  .content {
    padding-top: 60px;
    padding-bottom: 120px;
  }
}
</style>
